import React from 'react'
import styled from 'styled-components'
import utmLinkGenerator from '../../../utils/UTMLinkGenerator'
import { SIZES } from '../../../../constants'

const Container = styled.a`
  position: relative;
  display: flex;
  align-items: flex-end;

  &:hover {
    text-decoration: none;
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-bottom: 15px;
  }


  @media (min-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    max-width: 430px;
  }
`

const GiftImage = styled.img`
  position: absolute;
  bottom: -31px;

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    left: -23px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 105px;
  color: ${props => props.theme.header.valentinetips.color};
  font-size: 13px;

  p {
    margin: 0;
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-left: 88px;
  }
`

const BoldText = styled.p`
  font-weight: bold;
`

const ColorfulText = styled.p`
  color: ${props => props.theme.header.valentinetips.darkHighlightColor};

  &:hover {
    text-decoration: underline;
  }
`

const ValentineTips = ({ widget, shouldShowValentineTips }) => {
  const {
    utmMedium,
    link,
    src
  } = widget

  if (shouldShowValentineTips === false) return null

  return (
    <Container href={utmLinkGenerator.createLink(link, {
      utmMedium
    })}>
      <GiftImage src={`${STATICS_PATH}${src}`} alt='valentinské tipy'/>
      <TextContainer>
        <BoldText>Valentýn se blíží! Přinášíme tipy, jak si ho užít, i když svátek zamilovaných neslavíte.</BoldText>
        <ColorfulText>Inspirujte se zde</ColorfulText>
      </TextContainer>
    </Container>
  )
}

export default ValentineTips
